/**
 * Created by Ivan on 17.05.2026
 */

// eslint-disable-next-line
let SeasonPassHelper = {};

SeasonPassHelper.capitalize = function (period) {
    return period.charAt(0).toUpperCase() + period.slice(1);
};

SeasonPassHelper.getStringKey = function (period, suffix) {
    return `SeasonPass${SeasonPassHelper.capitalize(period)}.${suffix}`;
};
